import React, { useEffect, useState } from "react";
import { X } from "react-bootstrap-icons";
import "../../Custom.css"; // custom styles

const daysOptions = [
  { label: "Any Day (All days of the week)", value: "any" },
  { label: "Weekdays (Monday to Friday)", value: "weekdays" },
  { label: "Weekends (Saturday to Sunday)", value: "weekends" },
  { label: "Monday", value: "monday" },
  { label: "Tuesday", value: "tuesday" },
  { label: "Wednesday", value: "wednesday" },
  { label: "Thursday", value: "thursday" },
  { label: "Friday", value: "friday" },
  { label: "Saturday", value: "saturday" },
  { label: "Sunday", value: "sunday" },
];

const WaitTimeSlotsDrawer = ({ isOpen, onClose, onSave, initialData }) => {
  const [timeSlots, setTimeSlots] = useState(
    initialData?.timeSlots || [
      {
        day: "any",
        fromHour: "8",
        fromMinute: "00",
        fromPeriod: "am",
        toHour: "5",
        toMinute: "00",
        toPeriod: "pm",
      },
    ]
  );

  useEffect(() => {
    if (initialData?.timeSlots?.length > 0) {
      setTimeSlots(initialData?.timeSlots);
    }
  }, [initialData]);

  const handleAddTimeSlot = () => {
    if (timeSlots.length < 3) {
      setTimeSlots([
        ...timeSlots,
        {
          day: "any",
          fromHour: "8",
          fromMinute: "00",
          fromPeriod: "am",
          toHour: "5",
          toMinute: "00",
          toPeriod: "pm",
        },
      ]);
    }
  };

  const handleRemoveTimeSlot = (index) => {
    setTimeSlots(timeSlots.filter((_, i) => i !== index));
  };

  const handleTimeSlotChange = (index, field, value) => {
    const updatedTimeSlots = timeSlots.map((slot, i) =>
      i === index ? { ...slot, [field]: value } : slot
    );
    setTimeSlots(updatedTimeSlots);
  };

  const handleSave = () => {
    const getDisplayDay = (dayValue) => {
      switch (dayValue) {
        case "any":
          return "Any Day";
        case "weekdays":
          return "Weekdays";
        case "weekends":
          return "Weekends";
        default:
          return dayValue.charAt(0).toUpperCase() + dayValue.slice(1);
      }
    };

    onSave({
      timeSlots,
      displayText: timeSlots
        .map(
          (slot) =>
            `${getDisplayDay(slot.day)} ${slot.fromHour}:${slot.fromMinute}${slot.fromPeriod} - ${slot.toHour}:${slot.toMinute}${slot.toPeriod}`
        )
        ?.join(", "),
    });
    onClose();
  };

  return (
    <>
      {/* Overlay */}
      {isOpen && <div className="drawer-overlay" onClick={onClose} />}

      {/* Drawer */}
      <div className={`drawer drawer-lg ${isOpen ? "open" : ""}`}>
        <div className="drawer-content">
          {/* Header */}
          <div className="drawer-header bg-light d-flex justify-content-between align-items-center p-3 border-bottom">
            <div>
              <h5 className="mb-1">Time Slots Configuration</h5>
              <p className="text-muted small">
                Set the time slots when the journey should proceed
              </p>
            </div>
            <button
              type="button"
              className="btn btn-link text-muted p-0"
              onClick={onClose}
            >
              <X size={20} />
            </button>
          </div>

          {/* Body */}
          <div className="drawer-body p-3 flex-grow-1 overflow-auto">
            {timeSlots.map((slot, index) => (
              <div key={index} className="card mb-3 position-relative">
                <div className="card-body">
                  {timeSlots.length > 1 && (
                    <button
                      className="btn-close position-absolute top-0 end-0 m-2"
                      onClick={() => handleRemoveTimeSlot(index)}
                    ></button>
                  )}
                  <div className="row g-3">
                    {/* Day Selection */}
                    <div className="col-md-4">
                      <label className="form-label">Day</label>
                      <select
                        value={slot.day}
                        onChange={(e) =>
                          handleTimeSlotChange(index, "day", e.target.value)
                        }
                        className="form-select"
                      >
                        {daysOptions.map((day) => (
                          <option key={day.value} value={day.value}>
                            {day.label}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* From Time */}
                    <div className="col-md-4">
                      <label className="form-label">From</label>
                      <div className="d-flex gap-2">
                        <select
                          value={slot.fromHour}
                          onChange={(e) =>
                            handleTimeSlotChange(index, "fromHour", e.target.value)
                          }
                          className="form-select"
                        >
                          {Array.from({ length: 12 }, (_, i) => i + 1).map(
                            (hour) => (
                              <option key={hour} value={hour}>
                                {hour}
                              </option>
                            )
                          )}
                        </select>
                        <select
                          value={slot.fromMinute}
                          onChange={(e) =>
                            handleTimeSlotChange(
                              index,
                              "fromMinute",
                              e.target.value
                            )
                          }
                          className="form-select"
                        >
                          <option value="00">00</option>
                          <option value="30">30</option>
                        </select>
                        <select
                          value={slot.fromPeriod}
                          onChange={(e) =>
                            handleTimeSlotChange(
                              index,
                              "fromPeriod",
                              e.target.value
                            )
                          }
                          className="form-select"
                        >
                          <option value="am">AM</option>
                          <option value="pm">PM</option>
                        </select>
                      </div>
                    </div>

                    {/* To Time */}
                    <div className="col-md-4">
                      <label className="form-label">To</label>
                      <div className="d-flex gap-2">
                        <select
                          value={slot.toHour}
                          onChange={(e) =>
                            handleTimeSlotChange(index, "toHour", e.target.value)
                          }
                          className="form-select"
                        >
                          {Array.from({ length: 12 }, (_, i) => i + 1).map(
                            (hour) => (
                              <option key={hour} value={hour}>
                                {hour}
                              </option>
                            )
                          )}
                        </select>
                        <select
                          value={slot.toMinute}
                          onChange={(e) =>
                            handleTimeSlotChange(
                              index,
                              "toMinute",
                              e.target.value
                            )
                          }
                          className="form-select"
                        >
                          <option value="00">00</option>
                          <option value="30">30</option>
                        </select>
                        <select
                          value={slot.toPeriod}
                          onChange={(e) =>
                            handleTimeSlotChange(index, "toPeriod", e.target.value)
                          }
                          className="form-select"
                        >
                          <option value="am">AM</option>
                          <option value="pm">PM</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}

            {/* Add Time Slot Button */}
            {timeSlots.length < 3 && (
              <button
                type="button"
                onClick={handleAddTimeSlot}
                className="btn btn-outline-info mt-2"
              >
                + Add Time Slot
              </button>
            )}
          </div>

          {/* Footer */}
          <div className="drawer-footer bg-light p-3 border-top d-flex justify-content-end gap-2">
            <button className="btn btn-outline-secondary" onClick={onClose}>
              Cancel
            </button>
            <button className="btn btn-info text-white" onClick={handleSave}>
              Save
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default WaitTimeSlotsDrawer;
